import { useState } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { Topbar, Sidebar, AccountIndex, ApplicationIndex, CreditIndex, FilesIndex, StatusIndex, Loader, BreadCrump, Flag } from "../../components";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPermissions } from "../../slices/staffSlice";
import { useLoan } from '../../hooks';
import EvaluationPanel from '../Loan/Evaluation/EvaluationPanel';
import { HugeiconsIcon } from '@hugeicons/react';
import { Flag01Icon } from '@hugeicons/core-free-icons';

const TAB_STYLE = ({ selected }) =>
    `shrink-0 px-6 py-3.5 text-sm font-medium border-b-2 -mb-px transition-colors focus:outline-none whitespace-nowrap ${
        selected
            ? 'border-[#1e3a6e] text-[#1e3a6e]'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
    }`;

function ApprovedLoan() {

    const location = useLocation();
    const { pathname } = location;
    const path = pathname.split("/");
    const loanType = path[2];
    const loanId = path[3];

    const { isLoading, loan } = useLoan(
        { loanId, loanType, state: null, approved: true, active: false, completed: false }
    );

    const [isModalOpen, setIsModalOpen] = useState(false);
    const isFlagModalOpen = () => setIsModalOpen(!isModalOpen);
    const isFlagModalClosed = () => setIsModalOpen(!isModalOpen);

    // Only roles with clients:blacklist (PM/HOC/CRM/HOR/admin) may flag accounts.
    const permissions = useSelector(selectPermissions);
    const canFlag = permissions?.includes('*:*') || permissions?.includes('clients:blacklist');

    return (
        <div className='main-container'>
            <Topbar />
            <Sidebar />

            <main className='main-content'>
                <section className='section-container space-y-5'>

                {loan ?
                    <>
                    <div className="flex items-center justify-between">
                        <BreadCrump
                            path='/facility-letters'
                            main="Approved Loans"
                            sub={isLoading ? <Loader color={"text-gray-700"} size={"w-4 h-4 ml-1"} /> : `${loan?.type} — ${loan?._id}`}
                        />

                        {canFlag && (
                            <button
                                type='button'
                                onClick={isFlagModalOpen}
                                className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-red-500 border border-red-100 rounded-lg bg-red-50/60 hover:bg-red-50 transition-colors"
                            >
                                <HugeiconsIcon icon={Flag01Icon} size={14} />
                                Flag
                            </button>
                        )}
                    </div>

                    <TabGroup>
                        <TabList className="flex border-b border-gray-200 bg-white rounded-t-xl">
                            {["Status", "Application", "Evaluation", "Credit Bureau", "Files", "Loan Account"].map((label) => (
                                <Tab key={label} className={TAB_STYLE}>{label}</Tab>
                            ))}
                        </TabList>

                        <TabPanels className="mt-0">
                            <TabPanel><StatusIndex loan={loan} /></TabPanel>
                            <TabPanel><ApplicationIndex loan={loan} /></TabPanel>
                            <TabPanel><EvaluationPanel loan={loan} /></TabPanel>
                            <TabPanel><CreditIndex loan={loan} /></TabPanel>
                            <TabPanel><FilesIndex loan={loan} /></TabPanel>
                            <TabPanel><AccountIndex loan={loan} /></TabPanel>
                        </TabPanels>
                    </TabGroup>
                    </>
                :
                <div className='w-full py-12 inline-flex justify-center items-center'>
                    <Loader color={"text-gray-500"} size={"w-6 h-6"} />
                </div>
                }
                </section>

                <Flag
                    isOpen={isModalOpen}
                    isClosed={isFlagModalClosed}
                />
            </main>
        </div>
    );
}

export default ApprovedLoan;
